module.exports = {
  siteUrl: `http://localhost:8000`, // Site domain. Do not include a trailing slash!

  postsPerPage: 9, // Number of posts shown on paginated pages (changes this requires sometimes to delete the cache)

  siteTitleMeta: `Stackwalker LLC`, // This allows an alternative site title for meta data for pages.
  siteDescriptionMeta: `Thoughts, stories and ideas.`, // This allows an alternative site description for meta data for pages.

  shareImageWidth: 1000, // Change to the width of your default share image
  shareImageHeight: 523, // Change to the height of your default share image

  shortTitle: `Stackwalker LLC`, // Used for App manifest e.g. Mobile Home Screen
  siteIcon: `favicon.png`, // Logo in /static dir used for SEO, RSS, and App manifest
  backgroundColor: `#e9e9e9`, // Used for Offline Manifest
  themeColor: `#15171A`, // Used for Offline Manifest
};
